import { FilterForm } from "@/types/filfer.type";
import axios from "axios";

// Helper to strip empty, null, or undefined query parameters
const cleanParams = (params: Record<string, any>) => {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
  }
  return result;
};

export const DashboardService = {
  predict: (filter: FilterForm, signal?: AbortSignal) => {
    return axios.get(`${process.env.NEXT_PUBLIC_API_URL}/predicts/import`, {
      signal,
      params: cleanParams({
        disease: filter.disease,
        year: filter.year,
        numsem: filter.numsem,
        prov: filter.prov,
        zs: filter.zs,
      }),
    });
  },

  getInterval: (filter: FilterForm, signal?: AbortSignal) => {
    const weekinterval =
      filter.week1 && filter.week2 ? `${filter.week1}-${filter.week2}` : undefined;

    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/predicts/trends/import/grouped`,
      {
        signal,
        params: cleanParams({
          disease: filter.disease,
          year: filter.year,
          prov: filter.prov,
          zs: filter.zs,
          weekinterval,
        }),
      }
    );
  },

  topFiveDisease: (filter: FilterForm, signal?: AbortSignal) => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/predicts/sync-top-diseases`,
      {
        signal,
        params: cleanParams({
          year: filter.year,
          prov: filter.prov,
          numsem: filter.numsem,
        }),
      }
    );
  },

  allDisease: (filter: FilterForm, signal?: AbortSignal) => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/predicts/sync-all-top-diseases`,
      {
        signal,
        params: cleanParams({
          year: filter.year,
          prov: filter.prov,
          numsem: filter.numsem,
        }),
      }
    );
  },

  topFiveProvince: (filter: FilterForm, signal?: AbortSignal) => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/predicts/sync-top-provinces`,
      {
        signal,
        params: cleanParams({
          disease: filter.disease,
          year: filter.year,
          numsem: filter.numsem,
        }),
      }
    );
  },

  allProvinces: (filter: FilterForm, signal?: AbortSignal) => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/predicts/sync-all-top-provinces`,
      {
        signal,
        params: cleanParams({
          disease: filter.disease,
          year: filter.year,
          numsem: filter.numsem,
        }),
      }
    );
  },

  getMaladie: async () => {
    return axios.get(`${process.env.NEXT_PUBLIC_AFIAGAP_API}/maladie/lists`);
  },

  getProvinces: async () => {
    return axios.get(`${process.env.NEXT_PUBLIC_API_URL}/predicts/with-zones`);
  },
};
